import {TdoTableActionsEnum} from './tdo-table.model';

export class TdoTableEvent {
  value: object;
  action: TdoTableActionsEnum;

  constructor(value: object, action: TdoTableActionsEnum = null) {
    this.value = value;
    if (action) {
      this.action = action;
    }
  }
}
